import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#4C4DEE",
  "stroke-width": "1.382",
  d: "M12.212 1.19c5.943 0 10.81 5.036 10.81 11.31s-4.867 11.31-10.81 11.31c-5.942 0-10.81-5.036-10.81-11.31S6.27 1.19 12.213 1.19Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M9.908 16.5v-1.008a96 96 0 0 0 1.716-1.668q.756-.756 1.176-1.38.42-.636.42-1.176 0-.564-.3-.852-.288-.3-.78-.3-.408 0-.744.24-.324.228-.612.54l-.96-.948q.564-.6 1.152-.9.588-.312 1.404-.312.756 0 1.32.3t.876.852q.324.54.324 1.272 0 .636-.36 1.308a8 8 0 0 1-.9 1.332q-.552.66-1.176 1.308.288-.036.648-.06.36-.036.624-.036h1.536V16.5z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }